import { gql } from "@apollo/client";

export const getAllKeyGroupsQuery = gql`

query($input: KeyGroupFilter!){
  getKeyGroups(input: $input) {
    message
    totalCount
    response {
      _id
      assignmentNotes
      description
      zoneId
      custodianType
      name
      assignmentDate
      keysCount
      custodianDetail
      returnRequested
      isKeyLost
      status
      custodianId
      
      zone {
        name
      }
    }
  }
}

`;


export const getKeyGroupDetailByIdQuery = gql`
query($getKeyGroupByIdId: String!){
  getKeyGroupById(id: $getKeyGroupByIdId) {
    message
    response {
      _id
      custodianType
      custodianDetail
      isKeyLost
      returnRequested
      returnRequestExpectedDate

      assignmentNotes
      custodianId
      zone {
        name
      }
      
      name
      keys {
        _id
        createdAt
        custodianType
        siteId
        custodianId
        keySerial
        status
        assignmentNotes
        custodianDetail
        returnRequested
        returnRequestExpectedDate
        isKeyLost
        keyTypes {
          accessCodes {
            code
          }
          type
          count
        }
        totalKeys
        
        dateReceived
        site {
          sitename
        }

      }
    }
  }
}
`;


export const getKeyGroupTransactionByGroupId = gql`
query($groupId: String!){
  getKeyGroupTransactionsByGroupId(groupId: $groupId) {
    message
    response
  }
}
`;

// ======================================================================================
// =========================================== ALL KEY QUERIES
// ======================================================================================

export const getAllKeysQuery = gql`

query($input: AllKeysFilterInput!){

  getAllKeys(input: $input) {
    message
    totalCount
    response {
      _id
      custodianId
      keySerial
      returnToCustomer
      returnRequested
      returnRequestExpectedDate
      custodianType
      assignmentDate
      isKeyLost
      dateReceived
      keyGroupId
      siteId
      custodianDetail

      auditStatus

      auditNextDate
      auditLastDate

      keygroup {
        name
      }
      status
      site {
        sitename
        postcode
        contractStartDate
        contractEndDate
        sitestatus
        customername

      }
      keyTypes {
        type
        count
        accessCodes {
          code
        }
      }
    }
  }
}
`;


export const getKeyByIdQuery = gql`
query($keyId: String!){
  getKeyById(keyId: $keyId) {
    message
    response {
      _id
      custodianId
      keySerial
      returnToCustomer
      custodianType
      assignmentDate
      isKeyLost
      dateReceived
      keyGroupId
      siteId
      custodianDetail
      totalKeys
      images
      returnRequested
      isReturned
      returnDate
      lostDate
      lostNotes
      lostReportedBy

      auditStatus
      auditNextDate
      auditLastDate

      keygroup {
        name
      }
      status
      site {
        sitename
        postcode
        contractStartDate
        contractEndDate
      }
      keyTypes {
        type
        count
        accessCodes {
          code
        }
      }
    }
  }
}
`;


export const getKeyTransactionById = gql`
query GetKeyTransactionsById($keyId: String!) {
  getKeyTransactionsById(keyId: $keyId) {
    message
    response
  }
}
`;


export const getKeyAuditResultsQuery = gql`
query($keyId: String!){
  getKeyAuditResult(keyId: $keyId) {
   
      _id
      auditFor
      keyId
      keyGroupId
      isFullyConfirmed
      overallNotes
      images
      keyConfirmations {
        keyType
        expectedCount
        confirmed
        reason
      }
    }
  
}
`;


// Query
export const GET_KEY_AUDIT_REQUEST_Query = gql`
  query GetKeyAuditRequest($auditRequestId: String!) {
    getKeyAuditRequest(auditRequestId: $auditRequestId) {
      message
      response
    }
  }
`;


export const GetKeyCurrentCustodianBySiteIdQuery = gql`
query GetKeyCurrentCustodianBySiteId($siteId: String!) {
  getKeyCurrentCustodianBySiteId(siteId: $siteId) {
    message
    response
  }
}`;

export const getKeyUnitStatusesQuery = gql`
query GetKeyUnitStatuses($keyId: String!) {
  getKeyUnitStatuses(keyId: $keyId) {
    message
    response {
      keyType
      index
      status
      lastImages
      imageSource
      lastEventDate
    }
  }
}`;